import { render, staticRenderFns } from "./BBBPublishedFiles.vue?vue&type=template&id=d1ceb9f8"
import script from "./BBBPublishedFiles.vue?vue&type=script&lang=js"
export * from "./BBBPublishedFiles.vue?vue&type=script&lang=js"
import style0 from "./BBBPublishedFiles.vue?vue&type=style&index=0&id=d1ceb9f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports